export default __webpack_public_path__ + "static/media/student.54da5b88.svg";